import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findByUsuario } from "./api-usuario-perfil";
import { changePerfil } from "./api-usuario";
import { setUsuario } from "./actions/actions";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import SettingsCard, { SelectableList } from "../Configuracao/SettingsCard";

export default function UsuarioPerfilTable() {
  const usuario = useSelector((state) => state.usuario);
  const [usuarioPerfis, setUsuarioPerfis] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const dispatch = useDispatch();
  const usuarioId = usuario?.id;

  useEffect(() => {
    if (!usuarioId) return;
    findByUsuario(usuarioId).then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
      } else {
        setUsuarioPerfis(data);
      }
    });
  }, [usuarioId]);

  const handleAtivar = (up) => {
    setIsSaving(true);
    changePerfil(up.perfil)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        dispatch(setUsuario(data));
        success("Perfil ativo alterado.");
      })
      .finally(() => setIsSaving(false));
  };

  if (usuarioPerfis.length === 0) return null;

  return (
    <SettingsCard title="Perfil Ativo" description="Perfil usado para acessar o sistema." contentPadding={false}>
      <SelectableList
        items={usuarioPerfis}
        getKey={(up) => up.codigo}
        getLabel={(up) => up.perfil}
        isSelected={(up) => usuario.perfil === up.perfil}
        onSelect={handleAtivar}
        disabled={isSaving}
      />
    </SettingsCard>
  );
}
